<div class="modal-header">
    <h4 class="modal-title text-danger font-weight-bold">Login</h4>
    <button type="button" class="close" aria-label="Close" (click)="close();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="form" novalidate>
        <div class="custom-panel-title text-center">Sign in to your Account</div>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Email</mat-label>
          <input type="email" matInput formControlName="email" >
          <mat-error *ngIf="form.controls.email.errors?.required || form.controls.email.errors?.email">
            Please enter a valid email address
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Password</mat-label>
          <input type="password" matInput formControlName="password">
          <mat-error *ngIf="form.controls.password.errors?.required">
            Password can't be blank.
          </mat-error>
        </mat-form-field>
        <div class="custom-control custom-checkbox mt-4 pt-2 mb-2 text-left">
          <input type="checkbox" class="custom-control-input" id="remember">
          <label class="custom-control-label" for="remember">Keep me logged in</label>
        </div>
      </form>
  </div>
  
  <div class="modal-footer">
    <button class="btn btn-danger text-white w-100 mt-4 font-weight-bold px-3 py-3" (click)="login()" *ngIf="!isLoading">SUBMIT</button>
    <button class="btn btn-danger text-white w-100 mt-4  px-3 py-3" disabled *ngIf="isLoading">
      <span class="spinner-grow spinner-grow-sm"></span>
      Loading..
    </button>
  </div>
  